/**
 * Tiny in-memory pending-verification store.
 * Persisted in ``sessionStorage`` so a page reload does not lose the flow,
 * but a full browser close does. This mirrors the httponly ``zmex_pending``
 * cookie that also carries the pending_id on the backend.
 */

const KEY = 'zmex_portal_pending_v1';

export function getPending() {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setPending(p) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(p));
  } catch {
    /* ignore quota errors */
  }
}

export function clearPending() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
